export const VIEWS = {
  DAY: "day",
  DAYS: "days",
};
